import type { Parchment } from 'quill/core';
import type Quill from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import linkIcon from '../../icons/non-prefilled/16x16/link.svg';
import replaceEmbedBlotWith from '../utils/replaceEmbedBlotWith';
import { useToolbarOverflowMenuClose } from './toolbar/Toolbar';

interface ConvertIntoLinkMenuItemProps {
  quill: Quill;
  blot: Parchment.EmbedBlot;
  link: string;
}

const ConvertIntoLinkMenuItem = ({
  quill,
  blot,
  link,
}: ConvertIntoLinkMenuItemProps) => {
  const closeOverflowMenu = useToolbarOverflowMenuClose();
  return (
    <MenuItem
      icon={linkIcon}
      onClick={() => {
        replaceEmbedBlotWith(quill, blot, link, { link });
        closeOverflowMenu();
      }}
      testId="convertIntoLinkMenuItem"
    >
      Convert into link
    </MenuItem>
  );
};

export default ConvertIntoLinkMenuItem;
